import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  AutomationsWorkflowsService,
  type TCWorkflowUpdateBodyParams,
  type TCWorkflowUpdateResponse,
} from 'src/api/generated';

interface UseUpdateWorkflowParams {
  workflowId: string;
  body: TCWorkflowUpdateBodyParams;
}

export const useUpdateWorkflowMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<TCWorkflowUpdateResponse, Error, UseUpdateWorkflowParams>({
    mutationFn: async ({ workflowId, body }) => {
      return AutomationsWorkflowsService.updateWorkflow(workflowId, body);
    },
    onSuccess: async (_data, variables) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [
            'automations/workflows/version',
            { workflowId: variables.workflowId, version: 'DRAFT' },
          ],
        }),
        queryClient.invalidateQueries({
          queryKey: [
            'automations/workflows/versions',
            { workflowId: variables.workflowId },
          ],
        }),
        queryClient.invalidateQueries({
          queryKey: ['automations/workflows'],
        }),
      ]);
    },
  });
};
